<script>
		import {game, user, view} from "../client.svelte.js";
		import {menuButtons} from "../App.svelte"
		import {whatsnew} from "../core.js"
    import LoginPanel from "../panels/LoginPanel.svelte";
    import Running from "./Running.svelte";

    let viewmode = $derived((game.ID) ? 'playing' : (view.adventure) ? 'preparing' : (user.ID) ? 'authent' : 'public')
		let intromenu = $derived(menuButtons.filter(menu => ['intro', 'rules', 'advt', 'hero', 'game'].includes(menu.button)))
		let runningGames = $derived(user.games.values().filter(game => game.adventure !== 'DEMO').toArray())

		// $inspect(`INTRO - running games`, runningGames)

    async function load_tutorial() {
				// alert("Die Demo-Funktion steht aktuell leider noch nicht zur Verfügung. Bitte schau in ein paar Wochen wieder vorbei.")
        user.commence_demo()
		}
</script>


<!-------------------------------- HTML -------------------------------------->

<div class="bg-image">
	{#if viewmode === 'public'}
		<LoginPanel />
	{/if}
	<div id="welcomeSection" class="section">
		<div class="home">
			<ul class="links" data-help="menu">
					{#each intromenu as item}
							{#if item.modes.includes(viewmode)}
									<li class="link" onclick={() => view.switch_layout(item.layout)}>
											<div class="fa icon-{item.icon} mainMenu-item-logo"></div>
											<span>{item.title}</span>
									</li>
							{/if}
					{/each}
			</ul>
			<div class="descript">
				<img class="logo" src="/static/buttons/new/logoText.svg" alt="Logo"/>
				<div class="teaser-headline">Das freie Rollenspiel</div>
				<div class="demo" data-help="demo" onclick={load_tutorial}>
					<img class="tutorial-image-button" src="/static/buttons/new/tutorialImageButton.png" alt="Logo"/>
					<button id=demo class="btn-primary btn-primary-circle petrol icon-play">Demo starten</button>
				</div>
			</div>
			<div class="teaser-text">
				<p>Pentelion ist ein Virtual Table Top (VTT) Spielsystem für Fantasy-Rollenspiele. Also kein Videospiel, sondern eine Plattform zum gemeinsamen Spielen in einer Gruppe. Sitzt man nicht im selben Raum, wird zusätzlich ein Kommunikationsprogramm benötigt.</p>
				<p>Es braucht eine Gruppe von Spielern und Spielerinnen, und einen Gamemaster oder -masterin. Der Fantasy-Hintergrund ist die Mittelerde-Welt von Tolkien. Pentelion war früher ein klassisches Pen-and-Paper-Rollenspielsystem, mit
					Charakterbögen, verschiedenen Würfeln und, je nach Bedarf, Spielplänen mit Spielfiguren zur genaueren Darstellung von Begegnungen und Kämpfen.</p>
				<p>All diese Funktionen sind nun in der Pentelion-App als VTT verfügbar.</p>
				<p>Die App enthält die Charakterbögen, das Erschaffen und Weiterentwickeln der Charaktere, die verschiedenen Eigenschaften und Fähigkeiten, ein eigenes Magiesystem und ein einzigartiges Kampfsystem. Fertigkeiten sind nicht durch den Beruf
					oder die Rasse des Charakters vorbestimmt, sondern eigentlich für alle erreichbar, je nach Eigenschaften des individuellen Charakters aber mit unterschiedlich hohem Punkte-Aufwand.</p>
				<p>Setzt Du eine Fertigkeit ein, kannst Du in der App virtuell darauf würfeln. Du kannst beim Würfeln auf Fähigkeiten mehr oder weniger Ehrgeiz investieren und erhältst so ggf. eine höhere Erfolgschance, aber auch eine höhere
					Patzer-Chance.</p>
				<p>Patzer kommen nicht selten vor, wenn man seine Fähigkeiten überschätzt und zu intensiv einsetzt. Der Gamemaster kann dann seine Fantasie einsetzen, wenn er überlegt, welches Missgeschick Deinem Charakter widerfährt. Die Gruppe hat meistens
					etwas zu lachen.</p>
				<p>(Fast) Alle Fähigkeiten, Kampffertigkeiten und Zauber werden in der App ausgewürfelt werden.</p>
				<p>Kommt es zu einer gefährlicheren Begegnung bzw. Kampf, kann die App dies auf Battlemaps darstellen. Die Bewegung der Token auf der Map ist nicht felderabhängig, sondern frei verschieblich. Der Kampf läuft in Sekunden-Darstellung ab, nicht
					rundenbasiert.</p>
				<p>Es gibt mehrere Kampfstile, die von den Charakteren erlernt werden können („flink“, „gezielt“, „kraftvoll“ usw.), wodurch sich sehr individuelle Charaktere heraus formen lassen.</p>
				<p>Dasselbe gilt für die verschiedenen Arten der Magie.</p>
				<p>Dies ermöglicht im Kampfmodus / auf der Battlemap ein recht individuelles Herausspielen von taktischen Vorteilen der einzelnen Charaktere und bietet für Spieler und Gamemaster eine hohe taktische Herausforderung. Die App kann, wenn der
					Gamemaster dies wünscht, auch etliche Bewegungen und Angriffe von Monstern automatisieren. Dadurch hat der Gamemaster im Kampf dann mehr Zeit für individuelle Manöver.</p>
				<p>Die App bietet eine Anzahl von Basis-Monstern bzw. -Gegnern mit voraus geformten Eigenschaften. Die App bietet zusätzlich freie Wahl der Tokens für die eigene Figur und für weitere selbstgemachte Gegner/Monster , für die Battlemaps. All
					dies kann nach eigener Fantasie in die App und in die eigenen Abenteuer eingefügt werden. Die Maps können nach Bedarf in der Größe / im Maßstab und in der Sichtweite angepasst werden.</p>
				<p>Das Eigenschaften-/Fähigkeiten- und Kampfsystem ist für die Spieler rasch zu erlernen und weitgehend selbsterklärend. Der Gamemaster sollte sich schon etwas ausführlicher damit befassen.</p>
				<p>Insgesamt bietet Pentelion viel Platz für die eigene Fantasie – bei der Erschaffung eigener Abenteuer, beim Gestalten eigener Gegner und Monster, beim Einbringen (fast) beliebiger Battle Maps, beim Spielen in der Runde und beim Ausfechten
					der Kämpfe auf den Maps.</p>
			</div>
		</div>
	</div>

	{#if runningGames.length > 0}
		<div class="running">
			<Running/>
		</div>
	{/if}

	<div id="whatsnewSection" data-help="whatsnew">
		<h2>Was ist neu?</h2>
		{#each whatsnew as entry}
			<div class="whatsnew-entry">
				<h3>{entry.version} – {entry.summary}</h3>
				<div class="whatsnew-columns">
					<div class="whatsnew-col">
						<h4>Server</h4>
						<ul>
							{#each entry.server as line}
								<li>{line}</li>
							{/each}
						</ul>
					</div>
					<div class="whatsnew-col">
						<h4>Client</h4>
						<ul>
							{#each entry.client as line}
								<li>{line}</li>
							{/each}
						</ul>
					</div>
				</div>
			</div>
		{/each}
	</div>

</div>


<!-------------------------------- HTML -------------------------------------->

<style lang="sass">
	#welcomeSection
		position: relative
		height: 85%

	.bg-image
		background-image: url("/static/images/background.png")
		height: 100%
		overflow-y: auto

	.home
		background: linear-gradient(90deg, rgba(37,38,38,0.7) 0%, rgba(37,38,38,0.4) 100%)
		position: absolute
		bottom: 100px
		width: 100%
		height: 240px
		padding-left: 100px
		margin-bottom: 75px

	.links
		background: linear-gradient(90deg, rgba(12,136,136,0.5) 0%, rgba(12,136,136,0) 100%)
		display: flex
		flex-flow: row nowrap
		padding-top: 5px
		padding-left: 432px
		margin: 0 0 0 40px
		padding-bottom: 5px

	.link
		display: flex
		flex-flow: row nowrap
		align-items: center
		padding-right: 15px
		font-weight: bold
		justify-content: center
		cursor: pointer

	.link:after
		content: ""
		/*content: "|"*/
		padding-left: 15px

	.link:last-child:after
		content: ''

	.link div.fa
		width: 24px
		/*height: 24px*/
		margin-right: 5px
		/*display: none*/
		opacity: 0.5

	.link span
		text-decoration-line: underline
		text-decoration-thickness: 1px

	.logo
		position: absolute
		left: 85px
		top: -155px
		width: 375px
		filter: drop-shadow(0px 0px 12px rgba(0, 0, 0, 1))

	.descript
		display: flex
		flex-flow: row nowrap

	.teaser-headline
		padding: 30px 0 15px 190px
		font-size: 24px

	.teaser-text
		padding-left: 55px
		line-height: 1.5
		width: 750px
		height: 100%
		overflow: auto

	.demo
		margin-left: 180px
		position: absolute
		left: 740px
		top: 64px

		img
			width: 115px
			height: 115px

		button
			position: absolute
			top: 98px
			left: -30px

	/* ----------- Running Games ------------ */
	.running
		position: absolute
		right: 40px
		top: 40px

	/* ----------- What's new ------------ */
	#whatsnewSection
		background: rgba(37,38,38,0.7)
		padding: 30px 55px 60px 55px

		h2
			font-size: 24px
			margin: 0 0 20px 0

	.whatsnew-entry
		border-top: solid 1px rgba(255,255,255,0.2)
		padding: 20px 0

		h3
			margin: 0 0 10px 0

	.whatsnew-columns
		display: flex
		flex-flow: row nowrap
		gap: 40px

	.whatsnew-col
		flex: 1 1 0

		h4
			margin: 0 0 8px 0
			color: rgba(255,255,255,0.7)

		ul
			margin: 0
			padding-left: 20px

</style>